import { Link, useNavigate } from "react-router-dom";
import { Trash2 } from "lucide-react";
import { useCart } from "../context/CartContext";
import { money } from "../lib/api";
import Seo from "../components/Seo";

export default function Cart() {
  const { items, remove, setQty, subtotal } = useCart();
  const nav = useNavigate();

  return (
    <>
      <Seo title="Sepetim" />
      <section className="pt-32 pb-20 bg-brand-offwhite min-h-[60vh]">
        <div className="container-narrow px-6 lg:px-10">
          <h1 className="font-serif text-4xl md:text-5xl text-brand-green mb-10">Sepetim</h1>
          {items.length === 0 ? (
            <div data-testid="cart-empty" className="bg-brand-cream border border-brand-gold-light/40 rounded-sm p-12 text-center">
              <p className="text-brand-text/70">Sepetin boş.</p>
              <Link to="/magaza" className="inline-block mt-5 bg-brand-gold text-brand-offwhite px-6 py-3 rounded-sm font-semibold">Mağazaya Git</Link>
            </div>
          ) : (
            <div className="grid lg:grid-cols-3 gap-10">
              <div className="lg:col-span-2 space-y-4">
                {items.map((it) => (
                  <div key={it.product_id} data-testid={`cart-item-${it.product_id}`} className="flex gap-4 bg-brand-cream border border-brand-gold-light/40 rounded-sm p-4">
                    <img src={it.cover} alt={it.name} className="w-24 h-24 object-cover rounded-sm" />
                    <div className="flex-1">
                      <Link to={`/magaza/${it.slug}`} className="font-serif text-xl text-brand-green">{it.name}</Link>
                      <p className="text-brand-text/60 text-sm mt-1">{money(it.price)}</p>
                      <div className="flex items-center gap-3 mt-3">
                        <div className="flex items-center border border-brand-gold-light/50 rounded-sm text-sm">
                          <button onClick={() => setQty(it.product_id, it.quantity - 1)} data-testid={`cart-qty-dec-${it.product_id}`} className="px-3 py-1.5">−</button>
                          <span className="px-3" data-testid={`cart-qty-${it.product_id}`}>{it.quantity}</span>
                          <button onClick={() => setQty(it.product_id, it.quantity + 1)} data-testid={`cart-qty-inc-${it.product_id}`} className="px-3 py-1.5">+</button>
                        </div>
                        <button onClick={() => remove(it.product_id)} data-testid={`cart-remove-${it.product_id}`} className="text-red-700"><Trash2 size={18} /></button>
                      </div>
                    </div>
                    <div className="font-semibold text-brand-green">{money(it.price * it.quantity)}</div>
                  </div>
                ))}
              </div>
              <div className="bg-brand-green text-brand-offwhite rounded-sm p-8 h-fit">
                <h3 className="font-serif text-2xl mb-5">Özet</h3>
                <div className="flex justify-between text-sm mb-2"><span className="text-brand-offwhite/70">Ara toplam</span><span data-testid="cart-subtotal">{money(subtotal)}</span></div>
                <div className="flex justify-between text-sm mb-2"><span className="text-brand-offwhite/70">Kargo</span><span>Ücretsiz</span></div>
                <div className="border-t border-brand-offwhite/15 mt-4 pt-4 flex justify-between font-serif text-xl"><span>Toplam</span><span>{money(subtotal)}</span></div>
                <button onClick={() => nav("/odeme")} data-testid="checkout-btn" className="w-full mt-6 bg-brand-gold text-brand-offwhite hover:bg-brand-gold-light hover:text-brand-green transition-colors py-3.5 rounded-sm font-semibold">Ödemeye Geç</button>
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
}
